import * as React from 'react';
import { cn } from '@/lib/utils';

const IconStars = React.forwardRef(({ className, ...props }, ref) => (
  <svg
    ref={ref}
    width={62}
    height={91}
    viewBox="0 0 62 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('c-icon-stars', className)}
    {...props}
  >
    <path
      d="M26.3228 46.5639C26.8838 44.6457 29.6011 44.6457 30.162 46.5639L33.6468 58.4798C33.8383 59.1346 34.3503 59.6466 35.005 59.838L46.9209 63.3228C48.8391 63.8838 48.8391 66.6011 46.9209 67.162L35.005 70.6468C34.3503 70.8383 33.8383 71.3503 33.6468 72.005L30.162 83.9209C29.6011 85.8391 26.8838 85.8391 26.3228 83.9209L22.838 72.005C22.6466 71.3503 22.1346 70.8383 21.4798 70.6468L9.5639 67.162C7.64575 66.6011 7.64574 63.8838 9.5639 63.3228L21.4798 59.838C22.1346 59.6466 22.6466 59.1346 22.838 58.4798L26.3228 46.5639Z"
      fill="currentColor"
      className="animate-[classic-fade-in_.9s_ease-out_.6s_infinite]"
    />
    <path
      d="M12.9289 6.5639C13.4899 4.64574 16.2071 4.64575 16.7681 6.5639L17.901 10.4378C18.0925 11.0925 18.6045 11.6045 19.2592 11.796L23.1331 12.9289C25.0512 13.4899 25.0512 16.2071 23.1331 16.7681L19.2592 17.901C18.6045 18.0925 18.0925 18.6045 17.901 19.2592L16.7681 23.1331C16.2071 25.0512 13.4898 25.0512 12.9289 23.1331L11.796 19.2592C11.6045 18.6045 11.0925 18.0925 10.4378 17.901L6.5639 16.7681C4.64574 16.2071 4.64575 13.4898 6.5639 12.9289L10.4378 11.796C11.0925 11.6045 11.6045 11.0925 11.796 10.4378L12.9289 6.5639Z"
      fill="currentColor"
      className="animate-[classic-fade-in_.8s_ease-out_.2s_infinite]"
    />
    <path
      d="M38.8683 21.5639C39.4292 19.6457 42.1465 19.6457 42.7075 21.5639L45.1843 30.0332C45.3758 30.688 45.8878 31.2 46.5425 31.3914L55.0119 33.8683C56.93 34.4292 56.93 37.1465 55.0119 37.7075L46.5425 40.1843C45.8878 40.3758 45.3758 40.8878 45.1843 41.5425L42.7075 50.0119C42.1465 51.93 39.4292 51.93 38.8683 50.0119L36.3914 41.5425C36.2 40.8878 35.688 40.3758 35.0332 40.1843L26.5639 37.7075C24.6457 37.1465 24.6457 34.4292 26.5639 33.8683L35.0332 31.3914C35.688 31.2 36.2 30.688 36.3914 30.0332L38.8683 21.5639Z"
      fill="currentColor"
      className="animate-[classic-fade-in_.7s_ease-out_.4s_infinite]"
    />
  </svg>
));
IconStars.displayName = 'IconStars';

export { IconStars };
